/** @jsxImportSource @emotion/react */

const unaLinea = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
};

// Tarjeta compacta para grillas de pendientes y destacados: arriba el tipo
// con su ícono, después el título y debajo las líneas de detalle (textos o
// nodos; las vacías se saltean). Con onClick, toda la tarjeta es clickeable.
export default function TarjetaCompacta({
  icono,
  etiqueta,
  titulo,
  lineas = [],
  onClick,
  className = "col-12 md:col-6 lg:col-4 xl:col-3"
}) {
  return (
    <div className={className}>
      <div
        onClick={onClick}
        css={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "4px",
          padding: "10px 12px",
          borderRadius: "10px",
          backgroundColor: "white",
          boxShadow: "0 1px 4px rgba(0, 0, 0, 0.12)",
          cursor: onClick ? "pointer" : "default",
          transition: "box-shadow 0.15s",
          "&:hover": onClick
            ? { boxShadow: "0 3px 10px rgba(0, 0, 0, 0.18)" }
            : {}
        }}
      >
        <div
          css={{
            fontSize: "0.75rem",
            color: "var(--grisTextos)",
            textTransform: "uppercase",
            ...unaLinea
          }}
        >
          <i className={icono} css={{ marginRight: "0.4em" }}></i>
          {etiqueta}
        </div>

        <strong css={unaLinea}>{titulo}</strong>

        {lineas.filter(Boolean).map((linea, indice) => (
          <div
            key={indice}
            css={{
              fontSize: "0.85rem",
              color: "var(--grisTextos)",
              ...unaLinea
            }}
          >
            {linea}
          </div>
        ))}
      </div>
    </div>
  );
}
